import { PlusIcon, WalletIcon , ArrowDownLeftIcon, ArrowUpRightIcon } from '@heroicons/react/20/solid'
import { CashFlowFormDialog } from './cash-flow-form-dialog';
import { useEffect, useState } from 'react';
import useApi from 'src/configs/api';
import { useAlert } from 'src/hooks/use-alert';
import { FormMode } from 'src/models';
import { Dialog } from 'src/components/ui/dialog';
import { CashFlowModels } from '../../models/cash-flows';

const CashFlows = () => {
    const callAPi = useApi();
    const {showAlert, showSuccess, showError} = useAlert();
    const [mode, setMode] = useState<FormMode>("add");
    const [showCashFlowForm, setshowCashFlowForm] = useState<boolean>(false);
    const [selectedCashFlow, setSelectedCashFlow] = useState<CashFlowModels.Form | null>(null);
    const [flowSummary, setFlowSummary] = useState<CashFlowModels.CashFlowSummary[]>([]);
    
    useEffect(() => {
        FetchSummaries();

    }, [])

    const FetchSummaries = async() => {
        try
        {
            const summary = await callAPi.get("/finance/cash-flows/summary");
            const data = summary.data.data;
            setFlowSummary(data)
        }
        catch
        {
            showError("", "An error occured")
        }
    }

    const handleAdd = () =>{
        setMode("add")
        setshowCashFlowForm(true);
        setSelectedCashFlow(null);
    }

    const handleDialogChange = (open: boolean) => {
        setshowCashFlowForm(open);

        if (!open) {
            setMode("add");
            setSelectedCashFlow(null);
        }
    };

    return(
        <>
            <div className="p-2 lg:px-2 overflow-hidden">
                <div className="lg:mx-0 lg:max-w-none overflow-hidden">
                    <div className="relative">
                        <div className="absolute inset-0 flex items-center" aria-hidden="true">
                            <div className="w-full border-t border-gray-300" />
                        </div>
                        <div className="relative flex items-center justify-between">
                            <span className="bg-white pr-3 text-2xl font-semibold tracking-tight text-neutral-600">Cash Flows</span>
                            <button
                            onClick={handleAdd}
                            type="button"
                            className="inline-flex items-center gap-x-1.5 rounded-full bg-white px-3 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                            >
                            <PlusIcon className="-ml-1 -mr-0.5 h-5 w-5 text-gray-400" aria-hidden="true" />
                            <span>New Transaction</span>
                            </button>
                        </div>
                    </div>
                    <div className="mt-5 grid  max-w-xl text-sm md:text-base text-justify  gap-5 leading-7 text-gray-700 lg:max-w-none ">
                        <div className="grid grid-cols-1 gap-4">
                            {
                                flowSummary && flowSummary.map( summary => (
                                    <div key={summary.currencyCode}>
                                        <CashFlowSummaryCard  {...summary}  />
                                    </div>
                                ))
                            }
                        </div>

                        <div className='grid md:grid-cols-3 gap-2 md:gap-4'>
                            <div className="md:col-span-2 p-3 border inset-shadow-sm rounded-xl leading-7" >
                                <div className='text-medium font-semibold'>
                                    Recent Transactions
                                </div>
                                <div >
                                    <table className="min-w-full divide-y divide-gray-300">
                                    <thead>
                                        <tr className='text-gray-600'>
                                        <th scope="col" className="py-3.5  pr-3 text-left text-sm  sm:pl-0">
                                            Name
                                        </th>
                                        <th
                                            scope="col"
                                            className="hidden px-3 py-3.5 text-left text-sm  lg:table-cell"
                                        >
                                            Title
                                        </th>
                                       
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm ">
                                            Role
                                        </th>
                                        <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                                            <span className="sr-only">Edit</span>
                                        </th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white">

                                    </tbody>
                                        <tr>
                <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-0">

                                            a</td>
                                            <td>a</td>
                                            <td>a</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div className="p-3 border bg-gray-100 rounded-xl leading-7" >
                                Most Spent 
                            </div>

                        </div>
                    
                    </div>
                </div>
                <Dialog open={showCashFlowForm} onOpenChange={handleDialogChange} >
                    <CashFlowFormDialog open={showCashFlowForm} mode={mode} onOpenChange={handleDialogChange} data={selectedCashFlow} />
                </Dialog>
            </div>
        </>
    )


}


export const CashFlowSummaryCard: React.FC<CashFlowModels.CashFlowSummary> = ({currencyCode, balance, cashIn, cashOut}) => {
    return (
        <div className='m-0 grid md:grid-cols-3 gap-3 p-4 bg-gray-100 border rounded-xl'>
            <div className='md:p-3 grid md:col-span-1 col-span-2 md:grid-cols-3 text-center bg-white rounded-xl border p-4 shadow-sm hover:shadow-md transition rounded-xl p-4 flex flex-col items-center justify-center text-center shadow-sm' >

                <div className='flex justify-center items-center font-bold'>
                    <WalletIcon className="text-center text-gray-500 h-6 w-6 mb-1" />
                </div>

                <div className='md:col-span-2'>
                    <p className=" text-sm font-semibold text-gray-500 uppercase">  Balance </p>
                    {              
                        <p className="text-lg font-semibold text-gray-600">
                            {currencyCode} {balance.toLocaleString("id-ID")}
                        </p>
                    }
                </div>
            </div>
            <div className="grid md:grid-cols-3 bg-white rounded-xl border p-4 shadow-sm hover:shadow-md transition rounded-xl p-4 flex flex-col items-center justify-center text-center shadow-sm">
                <div className='flex justify-center items-center font-bold'>
                    <ArrowDownLeftIcon className="text-green-500 h-5 w-5 md:h-6 md:w-5 mb-1" />
                </div>
                <div className='md:col-span-2 '>
                    <p className="text-sm font-medium text-gray-500">  Cash In </p>

                    {
                        <p className="text-lg font-semibold text-green-600">
                            {currencyCode} {cashIn.toLocaleString("id-ID")}
                        </p>
                    }
                </div>


            </div>
            <div className="grid md:grid-cols-3 bg-white rounded-xl border p-4 shadow-sm hover:shadow-md transition rounded-xl p-4 flex flex-col items-center justify-center text-center shadow-sm">
                <div className='flex justify-center items-center'>
                <ArrowUpRightIcon className="text-red-500 h-5 w-5 md:h-6 md:w-5 mb-1" />
                </div>


                <div className='md:col-span-2 '> 
                    <div className=" text-sm font-medium text-gray-500">  Cash Out </div>

                    {
                        <p className="text-lg font-semibold text-red-600">
                            {currencyCode} {cashOut.toLocaleString("id-ID")}
                        </p>
                    }
                </div>
                
            </div>
        </div>
    )
}

export default CashFlows;